import React, { useEffect } from 'react';
import { ResponsiveBar } from '@nivo/bar'
import { convertCost } from '../../../Utils/functions';
import '../Stats.scss'

export const salesMockData = [//매출 분석 목업 데이터
    {
      "keys": "0~1시",
      "전체": 23,
      "배달": 142,
      "홀": 78,
    },
    {
      "keys": "1~2시",
      "전체": 87,
      "전체Color": "#d9d9d9",
      "배달": 37,
      "배달Color": "#f95f53",
      "홀": 30,
      "홀Color": "#ffc0bb",
    },
    {
      "keys": "2~3시",
      "전체": 1,
      "전체Color": "hsl(143, 70%, 50%)",
      "배달": 75,
      "배달Color": "hsl(102, 70%, 50%)",
      "홀": 158,
      "홀Color": "hsl(172, 70%, 50%)",
    },
    {
      "keys": "3~4시",
      "전체": 69,
      "전체Color": "hsl(281, 70%, 50%)",
      "배달": 15,
      "배달Color": "hsl(354, 70%, 50%)",
      "홀": 105,
      "홀Color": "hsl(12, 70%, 50%)",
    },
    {
      "keys": "4~5시",
      "전체": 188,
      "전체Color": "hsl(260, 70%, 50%)",
      "배달": 45,
      "배달Color": "hsl(52, 70%, 50%)",
      "홀": 194,
      "홀Color": "hsl(4, 70%, 50%)",
    },
    {
      "keys": "5~6시",
      "전체": 118,
      "전체Color": "hsl(281, 70%, 50%)",
      "배달": 39,
      "배달Color": "hsl(321, 70%, 50%)",
      "홀": 181,
      "홀Color": "hsl(166, 70%, 50%)",
    },
    {
      "keys": "6~7시",
      "전체": 170,
      "전체Color": "hsl(61, 70%, 50%)",
      "배달": 123,
      "배달Color": "hsl(264, 70%, 50%)",
      "홀": 68,
      "홀Color": "hsl(228, 70%, 50%)",
    },
    {
        "keys": "7~8시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
    },
    {
        "keys": "8~9시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
      },
      {
        "keys": "9~10시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
      },
      {
        "keys": "10~11시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
        "kebab": 49,
        "kebabColor": "hsl(201, 70%, 50%)",
        "fries": 118,
        "friesColor": "hsl(58, 70%, 50%)",
        "donut": 33,
        "donutColor": "hsl(198, 70%, 50%)"
      },
      {
        "keys": "11~12시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
        "kebab": 49,
        "kebabColor": "hsl(201, 70%, 50%)",
        "fries": 118,
        "friesColor": "hsl(58, 70%, 50%)",
        "donut": 33,
        "donutColor": "hsl(198, 70%, 50%)"
      },
      {
        "keys": "12~13시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
        "kebab": 49,
        "kebabColor": "hsl(201, 70%, 50%)",
        "fries": 118,
        "friesColor": "hsl(58, 70%, 50%)",
        "donut": 33,
        "donutColor": "hsl(198, 70%, 50%)"
      },
      {
        "keys": "13~14시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
        "kebab": 49,
        "kebabColor": "hsl(201, 70%, 50%)",
        "fries": 118,
        "friesColor": "hsl(58, 70%, 50%)",
        "donut": 33,
        "donutColor": "hsl(198, 70%, 50%)"
      },
      {
        "keys": "14~15시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
        "kebab": 49,
        "kebabColor": "hsl(201, 70%, 50%)",
        "fries": 118,
        "friesColor": "hsl(58, 70%, 50%)",
        "donut": 33,
        "donutColor": "hsl(198, 70%, 50%)"
      },
      {
        "keys": "15~16시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
        "kebab": 49,
        "kebabColor": "hsl(201, 70%, 50%)",
        "fries": 118,
        "friesColor": "hsl(58, 70%, 50%)",
        "donut": 33,
        "donutColor": "hsl(198, 70%, 50%)"
      },
      {
        "keys": "16~17시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
        "kebab": 49,
        "kebabColor": "hsl(201, 70%, 50%)",
        "fries": 118,
        "friesColor": "hsl(58, 70%, 50%)",
        "donut": 33,
        "donutColor": "hsl(198, 70%, 50%)"
      },
      {
        "keys": "18~19시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
        "kebab": 49,
        "kebabColor": "hsl(201, 70%, 50%)",
        "fries": 118,
        "friesColor": "hsl(58, 70%, 50%)",
        "donut": 33,
        "donutColor": "hsl(198, 70%, 50%)"
      },
      {
        "keys": "19~20시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
        "kebab": 49,
        "kebabColor": "hsl(201, 70%, 50%)",
        "fries": 118,
        "friesColor": "hsl(58, 70%, 50%)",
        "donut": 33,
        "donutColor": "hsl(198, 70%, 50%)"
      },
      {
        "keys": "20~21시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
        "kebab": 49,
        "kebabColor": "hsl(201, 70%, 50%)",
        "fries": 118,
        "friesColor": "hsl(58, 70%, 50%)",
        "donut": 33,
        "donutColor": "hsl(198, 70%, 50%)"
      },
      {
        "keys": "21~22시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
      },
      {
        "keys": "22~23시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
        "kebab": 49,
        "kebabColor": "hsl(201, 70%, 50%)",
        "fries": 118,
        "friesColor": "hsl(58, 70%, 50%)",
        "donut": 33,
        "donutColor": "hsl(198, 70%, 50%)"
      },
      {
        "keys": "23~24시",
        "전체": 170,
        "전체Color": "hsl(61, 70%, 50%)",
        "배달": 123,
        "배달Color": "hsl(264, 70%, 50%)",
        "홀": 68,
        "홀Color": "hsl(228, 70%, 50%)",
        "kebab": 49,
        "kebabColor": "hsl(201, 70%, 50%)",
        "fries": 118,
        "friesColor": "hsl(58, 70%, 50%)",
        "donut": 33,
        "donutColor": "hsl(198, 70%, 50%)"
      }
  ]

const SalesChart = ({data}) => {
  const [ chartData, setChartData ] = React.useState({});//매출 분석 데이터

  useEffect(() => {
    setChartData(data)
  },[])

  useEffect(() => {
    setChartData(data)
  },[data])
  
  return (
    <div style={{  height : 420, width : data.length > 7 ? data.length * 100 : '100%' }}>
      <ResponsiveBar
        data={chartData}
        keys={[
          '전체',
          '홀',
          '배달'
        ]}
        indexBy="keys"
        margin={{ top: 50, bottom: 50, left: 80 }}
        padding={0.5}
        innerPadding={2}
        groupMode="grouped"
        colors={[
          "#d9d9d9",
          "#f95f53",
          "#ffc0bb"
        ]}
        borderRadius={4}
        borderColor={{
          from: 'color',
          modifiers: [
            [
              'darker',
              1.6
            ]
          ]
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: '',
          legendPosition: 'middle',
          legendOffset: 32
        }}
        axisLeft={{
          orient : 'left',
          tickSize: 5,
          tickPadding: 24,
          tickRotation: 0,
          legend: '',
          legendPosition: 'middle',
          legendOffset: -40,
          format : value =>
            convertCost(value/1000) + 'k'
        }}
        tooltip={({id, value}) => (
          <div className='tooltip' style={{ backgroundColor : '#303030', padding : 8, paddingTop : 6, paddingBottom : 6, borderRadius : 8 }}>
            {
              (typeof id !== 'undefined' && typeof value !== 'undefined') &&
              <p style={{ fontSize : 12, fontWeight : 500, lineHeight : 1.33, color : 'white'}}>{id} 평균 매출 : {convertCost(value)}원</p>
            }
          </div>
        )}
        enableLabel={false}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{
          from: 'color',
          modifiers: [
            [
                'darker',
                1.6
            ]
          ]
        }}
        legends={[
          {
            dataFrom: 'keys',
            anchor: 'top-left',
            direction: 'row',
            justify: false,
            translateX: -48,
            translateY: -48,
            itemsSpacing: 16,
            itemWidth: 48,
            itemHeight: 17,
            itemDirection: 'left-to-right',
            itemOpacity: 0.85,
            symbolSize: 16,
            symbolShape : 'circle',
            effects: [
              {
                on: 'hover',
                style: {
                  itemOpacity: 1
                }
              }
            ]
          }
        ]}
        role="application"
      />
    </div>
  )
}

export default SalesChart;